import { Tooltip } from "@mui/material";
import React from "react";

const UseTooltipOnString = ({ string, lengthForTooltip }) => {
  const displayString = string || "N/A";
  const shouldShowToolTip = displayString.length > lengthForTooltip;
  return (
    <>
      {shouldShowToolTip ? (
        <Tooltip title={displayString} placement="top" arrow>
          <span>{`${
            string?.charAt(0)?.toUpperCase() +
            string?.slice(1, lengthForTooltip)
          }...`}</span>
        </Tooltip>
      ) : (
        <span>{string?.charAt(0)?.toUpperCase() + string?.slice(1)}</span>
      )}
    </>
  );
};

export default UseTooltipOnString;
